import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import {
  PAGE_SIZE,
  MAX_SIZE,
  CURRENCY_SYB,
} from 'src/app/onelog/common/config/common';
import { environment } from 'src/environments/environment';
import { FINANCE_ROYALTY_RATE_V2 } from 'src/app/onelog/common/config/url';

@Component({
  selector: 'app-finance-royalty-rates-v2',
  templateUrl: './finance-royalty-rates-v2.component.html',
  styleUrls: ['./finance-royalty-rates-v2.component.css'],
})
export class FinanceRoyaltyRatesV2Component implements OnInit {
  constructor(private _requestService: RequestService) {}

  apiURL = environment.sachWebURL;
  selectedproductId: string = '';
  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  showSearchLoading: boolean = false;
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;
  Currency: any = CURRENCY_SYB;
  searchBtnText: string = 'Search';
  responseData: any = [];

  ngOnInit(): void {
    this.loadProducts(this.createPostData());
  }

  // Define subjects and terms
  royaltyTypes = [
    'ebook_band',
    'print_band',
    'video_band',
    'course_band',
    'translation_band',
    'packtlib_band',
    'third_party_band',
    'audiobook_band',
    'quizzes_band',
  ];
  bands = ['1', '2', '3'];

  // Function to get royalty fields
  getRoyaltytFields(royaltyType: string) {
    return this.bands.map((bands) => `${royaltyType}_${bands}`);
  }

  // Function to get royalty data for a specific band
  getRoyaltyBandData(product: any, royaltyType: string) {
    return this.getRoyaltytFields(royaltyType).map((field) => product[field]);
  }

  royaltyNames: any = {
    ebook_band: 'eBook',
    print_band: 'Print',
    video_band: 'Video',
    course_band: 'Course',
    translation_band: 'Print',
    packtlib_band: 'PacktLib Subscription',
    quizzes_band: 'Quizzes',
    third_party_band: '3rd Part Subscription',
    audiobook_band: 'AudioBook',
  };

  getRoyaltyValue(key: string): string {
    return this.royaltyNames[key] || '';
  }

  loadProducts(postData: any = [], url: string = FINANCE_ROYALTY_RATE_V2) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = this.responseData.data;
        this.totalProducts = this.responseData.total;
        this.perPage = this.responseData.per_page;
        this.lastPage = this.responseData.last_page;
        this.currentPage = this.responseData.current_page;
        console.log(data);
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    //console.log(eventData);
    let urlParams = '?page=' + eventData.currentPage;
    this.loadProducts(
      this.createPostData(),
      `${FINANCE_ROYALTY_RATE_V2}${urlParams}`
    );
  }

  createPostData() {
    return {
      selectedproductId: this.selectedproductId,
    };
  }

  downloadReport() {
    this._requestService.download(
      FINANCE_ROYALTY_RATE_V2,
      {
        is_download: 1,
        selectedproductId: this.selectedproductId,
      },
      '',
      'Finance_Royalty_Report'
    );
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log({
      selectedproductId: this.selectedproductId,
    });

    this.loadProducts(this.createPostData());
  }
}
